import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import get from 'lodash/get';

import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import * as PaymentsActions from 'rebook/apps/payments/actions/PaymentsActions';
import * as UserWalletsActions from 'rebook/apps/users/actions/UserWalletsActions';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import PaymentsSubscriptionHeader from 'rebook/apps/payments/components/PaymentsSubscriptionHeader';
import Article from 'rebook/apps/base/components/Article';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';

import PaymentsSubscriptionTypeOffer from './PaymentsSubscriptionTypeOffer';
import PaymentsSubscription from './PaymentsSubscription';
import PaymentsFAQ from './PaymentsFAQ';
import PaymentsGiftSubscription from './PaymentsGiftSubscription';
import styles from './style.scss';


class PaymentsView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(PaymentsActions.fetchInitialData());
  }

  componentWillMount() {
    // this method is called both server side and client side
    // we have to fill subscription types details with basic info such as 1 month price
    // so it can be properly rendered server side
    const { PaymentsActions } = this.props;
    PaymentsActions.updateSubscriptionTypes();
  }

  componentWillUnmount() {
    this.props.SeoActions.resetData();
  }

  componentDidMount() {
    // unlike componentWillMount this method is called client side only
    // user wallets should be fetched client side only
    // same goes for initial data and redeem code restore
    const { UserWalletsActions, PaymentsActions, user } = this.props;
    PaymentsActions.parseInitialDataFromHistory(this.props.history);
    PaymentsActions.fetchInitialData();
    PaymentsActions.restoreRedeemCode(this.props.history);

    if (user) {
      UserWalletsActions.fetchWallets();
    }
  }

  componentDidUpdate(prevProps) {
    const { history, location, PaymentsActions, UserWalletsActions, user, userWallets } = this.props;
    const { prices, isGift } = this.props.payments;

    if (isGift !== prevProps.payments.isGift) {
      PaymentsActions.fetchPrices();
    }

    // change prices once user logs in or logs out
    if (user !== prevProps.user) {
      PaymentsActions.restoreRedeemCode(history);
      PaymentsActions.fetchPrices();

      if (user) {
        UserWalletsActions.fetchWallets();
      }
    }

    if (user !== prevProps.user || prices !== prevProps.payments.prices || userWallets !== prevProps.userWallets) {
      PaymentsActions.updateSubscriptionTypes();
    }

    // update internal state when user goes back and forth in browser history
    const newLocationState = this.props.location.state || {};
    if (prevProps.location !== location) {
      PaymentsActions.updateState({
        state: {
          ...newLocationState,
          subscriptionType: newLocationState.subscriptionType || null,
          isGift: newLocationState.isGift || false,
        },
      });
    }
  }

  changeSubscriptionType(type, isGift = false) {
    const { isGift: wasGift } = this.props.payments;
    ga('send', 'event', 'Payments', 'SubscriptionType', type);

    let query = {
      subscription_type: type,
    };

    if (isGift) {
      query.gift = '1';
    }

    this.props.PaymentsActions.updateState({
      state: {
        subscriptionType: type,
        isGift,
      },
      query,
      history: this.props.history,
      // push subscription type change with a new history item along with state
      // so the user is able to return to the subscription selection screen
      // either with left swipe or the back button in desktop
      isHistoryPush: true,
    });
    // prices are different for gift
    if (wasGift !== isGift) {
      this.props.PaymentsActions.fetchPrices();
    }

    this.scrollToTop();
  }

  changeSubscriptionPeriod(period) {
    this.props.PaymentsActions.updateState({
      state: {
        subscriptionPeriod: period,
      },
      history: this.props.history,
      query: {
        months: period,
      },
    });
  }

  changePaymentMethod(method) {
    this.props.PaymentsActions.updateState({
      state: {
        paymentMethod: method,
      },
      history: this.props.history,
      query: {
        method,
      },
    });
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  render() {
    const { subscriptionType, subscriptionTypes, prices, isGift } = this.props.payments;
    const { promoCampaign } = this.props;
    const userEmail = this.props.user && this.props.user.email;
    const promoCampaignExist = get(promoCampaign, 'platforms[0]', '') === 'web';

    if (!prices) {
      return (
        <div className={styles.loader}>
          <SpinnerLoader />
        </div>
      );
    }
    const isShowOfferLink = !get(this.props.user, 'subscription_audio_active_till', false);
    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        {subscriptionType
          ? (
            <React.Fragment>
              <div className="section">
                <BreadCrumbs links={[
                  { text: 'Подписка', url: '/payments/' },
                  {
                    text: subscriptionType === 'pro' ? 'Премиум' : 'Стандартная',
                    url: `/payments/${subscriptionType === 'pro'
                      ? '?subscription_type=pro'
                      : '?subscription_type=standard'}`,
                  },
                ]} />
              </div>
              {promoCampaignExist && (
                <div className={classNames(
                  'jest-payments-promo-campaigns',
                  styles.promoCampaign,
                )}>
                  <Article
                    textColor={promoCampaign.announcement_text_color}
                    htmlContent={promoCampaign.announcement_text} />
                </div>
              )}
              <PaymentsSubscriptionHeader
                type={subscriptionType}
                isGift={isGift}
                userEmail={userEmail}
                onChangeSubscriptionType={(type) => this.changeSubscriptionType(type)} />

              <div className={styles.paymentsSubscription}>
                <PaymentsSubscription
                  onSubscriptionPeriodChange={(newPeriod) => this.changeSubscriptionPeriod(newPeriod)}
                  onPaymentMethodChange={(newMethod) => this.changePaymentMethod(newMethod)}
                  {...this.state} />
              </div>
            </React.Fragment>
          )
          : (
            <React.Fragment>
              {promoCampaignExist && (
                <div className={styles.promoCampaign}>
                  <Article
                    textColor={promoCampaign.announcement_text_color}
                    htmlContent={promoCampaign.announcement_text} />
                </div>
              )}
              <div className={styles.subscriptionList}>
                <div className={styles.subscriptionListContainer}>
                  <div className={styles.subscriptionListTitle}>
                    <h1>Оформление подписки</h1>
                  </div>
                  <div className={classNames(
                    'jest-payments-subscription-types',
                    styles.subscriptionTypes,
                  )}>
                    {Object.keys(subscriptionTypes).map((subType) => (
                      <div className={styles.subscriptionType} key={subType}>
                        <PaymentsSubscriptionTypeOffer
                          user={this.props.user}
                          isShowOfferLink={isShowOfferLink}
                          type={subType}
                          onSubscriptionTypeChange={() => this.changeSubscriptionType(subType)} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className={styles.section}>
                <PaymentsGiftSubscription
                  onSubscriptionTypeChange={(newType) => this.changeSubscriptionType(newType, true)} />
              </div>
              <div className={styles.section}>
                <PaymentsFAQ />
                <div className={styles.navigation} onClick={() => this.scrollToTop()}>
                  <div className={styles.navigationArrow} />
                  <p className={styles.navigationTitle}>Оформить подписку</p>
                </div>
              </div>
            </React.Fragment>
          )
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    payments: state.payments,
    userWallets: state.userWallets,
    promoCampaign: state.promoCampaign,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    PaymentsActions: bindActionCreators(PaymentsActions, dispatch),
    UserWalletsActions: bindActionCreators(UserWalletsActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentsView);
